import ProfileImg from "../../assets/Group 62904.png";
const Review = [
  {
    id: 1,
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "If you're having a hard time with the integration of your CRM system, then the CRM system is not good. Seamless integration is the another best feature of Zoho. This CRM offers plenty of integration, from Office Suite, Telephony, Messaging, Events and meetings, Finance, Quote Management, Marketing Automation, Social Media, and many more.",
    video: "false",
  },
  {
    id: 2,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "true",
  },
  {
    id: 3,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "If you're having a hard time with the integration of your CRM system, then the CRM system is not good. Seamless integration is the another best feature of Zoho. This CRM offers plenty of integration, from Office Suite, Telephony, Messaging, Events and meetings, Finance, Quote Management, Marketing Automation, Social Media, and many more.",
    video: "true",
  },
  {
    id: 4,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "false",
  },
  {
    id: 5,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "false",
  },
  {
    id: 6,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "false",
  },
  {
    id: 7,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "If you're having a hard time with the integration of your CRM system, then the CRM system is not good. Seamless integration is the another best feature of Zoho. This CRM offers plenty of integration, from Office Suite, Telephony, Messaging, Events and meetings, Finance, Quote Management, Marketing Automation, Social Media, and many more.",
    video: "false",
  },
  {
    id: 8,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "If you're having a hard time with the integration of your CRM system, then the CRM system is not good. Seamless integration is the another best feature of Zoho. This CRM offers plenty of integration, from Office Suite, Telephony, Messaging, Events and meetings, Finance, Quote Management, Marketing Automation, Social Media, and many more.",
    video: "false",
  },
  {
    id: 9,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "true",
  },
  {
    id: 10,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "true",
  },
  {
    id: 11,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "true",
  },
  {
    id: 12,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "true",
  },
  {
    id: 13,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "true",
  },
  {
    id: 14,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "true",
  },
  {
    id: 15,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "true",
  },
  {
    id: 16,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "true",
  },
  {
    id: 17,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "true",
  },
  {
    id: 18,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "true",
  },
  {
    id: 19,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "true",
  },
  {
    id: 20,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "true",
  },
  {
    id: 21,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "true",
  },
];

export default Review;
